import React from "react";
import { Table } from "antd";
import round  from "lodash/round";
import get from "lodash/get";
import {
  checkNullable,
  getTransformedMinutes,
} from "../../../utilities/helpers";

const TableSummary = ({ summary, templateType }) => {
  switch (templateType) {
    case 1:
      return (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={1}>
            <p className="font-semibold text-center">Total</p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p className="text-center">
              {round(get(summary, "total_stats.total_shots")) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p className="text-center">
              {get(summary, "total_stats.total_count") || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <p className="text-center">
              {round(get(summary, "total_stats.total_power_consumption"),2) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <p className="text-center">
              {" "}
              {getTransformedMinutes(
                Number(round(get(summary, "total_stats.total_idle_hours")))
              ) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.machine_efficiency"))) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={11}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.availablity_ratio"))) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={12}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.quality_ratio"))) || 0}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      );
    case 2:
      return (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={1}>
            <p className="font-semibold text-center">Total</p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p className="text-center">
              {get(summary, "total_stats.total_length") || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <p className="text-center">
              {round(get(summary, "total_stats.total_power_consumption"),2) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <p className="text-center">
              {" "}
              {getTransformedMinutes(
                Number(round(get(summary, "total_stats.total_idle_hours")))
              ) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.machine_efficiency"))) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={11}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.availablity_ratio"))) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={12}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.quality_ratio"))) || 0}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      );
       case 3:
      return (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={1}>
            <p className="font-semibold text-center">Total</p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p className="text-center">
              {round(get(summary, "total_stats.total_count")) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <p className="text-center">
              {round(get(summary, "total_stats.total_power_consumption"),2) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <p className="text-center">
              {" "}
              {getTransformedMinutes(
                Number(round(get(summary, "total_stats.total_idle_hours")))
              ) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.machine_efficiency"))) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={11}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.availablity_ratio"))) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={12}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.quality_ratio"))) || 0}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      );
    case 4:
         return (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={1}>
            <p className="font-semibold text-center">Total</p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p className="text-center">
              {round(get(summary, "total_stats.total_count")) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <p className="text-center">
              {round(get(summary, "total_stats.total_power_consumption"),2) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <p className="text-center">
              {" "}
              {getTransformedMinutes(
                Number(round(get(summary, "total_stats.total_idle_hours")))
              ) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.machine_efficiency"))) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={11}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.availablity_ratio"))) || 0}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={12}>
            <p className="text-center">
              {checkNullable(round(get(summary, "total_stats.quality_ratio"))) || 0}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )
  }

};

export default TableSummary;
